<template>
  <v-select
    :label="$t('ReceiptBillAnalyze.objType.title')"
    v-model="SelectModel"
    :items="objType_flgs"
  ></v-select>
</template>

<script>
import { mapState } from "vuex";
import consts from "@/consts.js";

export default {
  name: "SearcherObjType",
  props: {
    value: Number,
  },
  data: () => ({
    SelectModel: 1,
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.SelectModel = this.value;
      },
    },
    SelectModel: {
      handler() {
        this.$emit("input", this.SelectModel);
      },
    },
  },
  computed: {
    objType_flgs() {
      return consts.objType();
    },

    //使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },
};
</script>
